import * as React from "react";
import { forwardRef } from "react";
const SvgOmniEmail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M22.0605 6C22.0605 4.9 21.1605 4 20.0605 4H4.06055C2.96055 4 2.06055 4.9 2.06055 6V18C2.06055 19.1 2.96055 20 4.06055 20H20.0605C21.1605 20 22.0605 19.1 22.0605 18V6ZM20.0605 6L12.0605 11L4.06055 6H20.0605ZM20.0605 18H4.06055V8L12.0605 13L20.0605 8V18Z", fill: "#7D7D7D" }));
const ForwardRef = forwardRef(SvgOmniEmail);
export { ForwardRef as ReactComponent };
